export const getEnvVariable = (
  name: string,
  defaultValue?: string
): string | undefined => process.env[name] || defaultValue;

export const isUatEnv = () => window.location.host.includes('uat');
export const isProdEnv = () =>
  window.location.host.includes('stem.acceleratelearning.com');
export const isProdCluster = () => isUatEnv() || isProdEnv();

export const isLocalEnv = () =>
  window.location.host.includes(
    'stem.dev.stemscopes-v4-dev.aws.acceleratelearning.com'
  ) && window.location.host.startsWith('local.');
